import {BackendFetch, FormatSimple, Tolgee, TolgeeStaticDataProp} from "@tolgee/vue";

export type AvailableLanguageKeys = 'ru' | 'en' | 'kz' | 'uz' | 'kk';

export const availableLanguages: AvailableLanguageKeys[] = ['ru', 'en', 'kz', 'uz'];
export const defaultLanguage = availableLanguages[0];
export const staticData: TolgeeStaticDataProp = {
	'ru': () => import('@/langs/ru.json').then(m => m.default),
	'en': () => import('@/langs/en.json').then(m => m.default),
	'uz': () => import('@/langs/uz.json').then(m => m.default),
	'kk': () => import('@/langs/kz.json').then(m => m.default),

	'ru:loader-payment-cashed': () => import('@/langs/loader-phrases/payment/cashed/ru.json').then(m => m.default),
	'en:loader-payment-cashed': () => import('@/langs/loader-phrases/payment/cashed/en.json').then(m => m.default),
	'uz:loader-payment-cashed': () => import('@/langs/loader-phrases/payment/cashed/uz.json').then(m => m.default),
	'kk:loader-payment-cashed': () => import('@/langs/loader-phrases/payment/cashed/kz.json').then(m => m.default),

	'ru:loader-payment-created': () => import('@/langs/loader-phrases/payment/created/ru.json').then(m => m.default),
	'en:loader-payment-created': () => import('@/langs/loader-phrases/payment/created/en.json').then(m => m.default),
	'uz:loader-payment-created': () => import('@/langs/loader-phrases/payment/created/uz.json').then(m => m.default),
	'kk:loader-payment-created': () => import('@/langs/loader-phrases/payment/created/kz.json').then(m => m.default),
};

export const tolgee = Tolgee()
	.use(FormatSimple())
	.use(BackendFetch({
		prefix: import.meta.env.VITE_TOLGEE_BACKEND_PREFIX_URL,
		fallbackOnFail: true,
		timeout: 3000,
	}))
	.init({
		language: defaultLanguage,
		staticData,
		ns: ['', 'loader-payment-cashed', 'loader-payment-created'],
		defaultLanguage,
		fallbackLanguage: defaultLanguage,
		availableLanguages,
	});

export const changeLanguage = async (lang: string) => {
	let locale;

	if (availableLanguages.includes(lang as AvailableLanguageKeys) || lang === 'kk') {
		locale = lang === 'kz' ? 'kk' : lang;
	} else {
		locale = defaultLanguage;
	}

	await tolgee.changeLanguage(locale);

	return locale as AvailableLanguageKeys;
}
